import { RegistrationOptionsResponse } from '../models/registration-options-response';
import globalAxios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { mergeHeaders, AxiosHeaders } from '../utilities/merge-headers';

export class OptionsApi {
    private baseUrl: string;

    public constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async get(headers?: AxiosHeaders): Promise<AxiosResponse<RegistrationOptionsResponse>> {
        const request = {
            url: this.baseUrl + '/options',
            method: 'GET',
            responseType: 'json',
        } as AxiosRequestConfig;

        request.headers = mergeHeaders(request.headers, headers);


        const response = await globalAxios.request<RegistrationOptionsResponse>(request);
        

        return response;
    }
}